import styled from "styled-components";

export const ModalOverlay = styled.div`
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 16px;
`;

export const ModalBox = styled.div`
    position: relative;
    background: #fff;
    border-radius: 8px;
    max-width: 640px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 15px;
    right: 15px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    font-size: 22px;
    line-height: 1;
    color: #1d1a1a;

    &:hover {
        opacity: 0.7;
    }
`;

export const ModalContent = styled.div`
    padding: 60px 8px 30px 8px;
    text-align: center;

    @media (min-width: 769px) {
        padding-left: 25px;
        padding-right: 25px;
    }
`;

export const ModalTitle = styled.div`
    font-family: 'Lato', sans-serif;
    font-weight: 500;
    font-size: 30px;
    line-height: 1;
    color: #fd3300;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;

    @media (min-width: 769px) {
        margin-bottom: 30px;
        flex-wrap: nowrap;
    }
`;

export const ModalTitleBreak = styled.br`
    @media (min-width: 769px) {
        display: none;
    }
`;

export const ModalTutorialText = styled.div`
    font-family: 'Lato', sans-serif;
    font-size: 15px;
    line-height: 1;
    font-weight: 500;
    letter-spacing: 0.3px;
    margin-bottom: 15px;

    @media (min-width: 769px) {
        font-size: 20px;
        margin-bottom: 8px;
    }
`;

export const AspectRatioBox = styled.div`
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
`;

export const ButtonRow = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 25px;
    margin-left: auto;
    margin-right: auto;
    max-width: 370px;

    @media (min-width: 769px) {
        flex-direction: row;
        max-width: unset;
    }
`;

export const PrimaryLinkButton = styled.a`
    display: block;
    width: 100%;
    font-family: 'Repro', sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    color: #fff;
    background-color: #fd3300;
    border: 1px solid #fd3300;
    border-radius: 100px;
    padding: 14px 20px;
    cursor: pointer;
    text-decoration: none;
    text-align: center;
    margin-bottom: 10px;

    @media (min-width: 769px) {
        display: inline-block;
        width: auto;
        margin-bottom: 0;
        margin-right: 15px;
        padding-left: 20px;
        padding-right: 20px;
    }

    &:hover {
        background-color: #e62a00;
        border-color: #cc2900;
        color: #fff;
    }
`;

export const OutlineCloseButton = styled.button`
    display: block;
    width: 100%;
    font-family: 'Repro', sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    color: #1d1a1a;
    background-color: transparent;
    border: 1px solid #1d1a1a;
    border-radius: 100px;
    padding: 14px 30px;
    cursor: pointer;
    text-align: center;

    @media (min-width: 769px) {
        display: inline-block;
        width: auto;
        padding-left: 30px;
        padding-right: 30px;
    }

    &:hover {
        opacity: 0.7;
    }
`;
